export default __webpack_public_path__ + "static/media/dsc01213_1.c3389f09.jpg";